// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29cd6b44","732":"c1b866c3","977":"301961f2"}[chunkId] + ".chunk.js";
};